//为element-ui的Message添加默认参数
import { Toast, Dialog } from 'vant'
import loading from './loading';

Toast.warning = Toast.success
Toast.error = Toast.fail
Toast.setDefaultOptions({ duration: 4000, forbidClick: false })
Toast.allowMultiple()

'alert,prompt'.split(',')

function dlg(fn, msg) {
    if (typeof msg === 'string') msg = { message: msg }
    msg.showCancelButton = true
    return fn(msg)
}


export default {
    msgBox: Dialog,
    toast: Toast,
    loading,
    alert: dlg.bind(0, Dialog.alert),
    confirm: dlg.bind(0, Dialog.alert),
}
